import { render } from "./GsVideoLive.vue?vue&type=template&id=15b33808&scoped=true"
import script from "./GsVideoLive.vue?vue&type=script&lang=ts"
export * from "./GsVideoLive.vue?vue&type=script&lang=ts"

import "./GsVideoLive.vue?vue&type=style&index=0&id=15b33808&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-15b33808"

export default script